import React, { useState } from "react";
import { Ticket } from "../../../models/Ticket";
import SingleFutureTicketDate from "./Other/SingleFutureTicketDate";
import SingleFutureTicketDetails from "./Other/SingleFutureTicketDetails";
import SingleFutureTicketActions from "./Other/SingleFutureTicketActions";
import EAModal from "../../shared/Modal/EAModal";
import { useTranslation } from "react-i18next";
import QrCodeModal from "../../../../features/QRcode";
import useFacility from "../../../../utils/hooks/useFacility";
import { post } from "../../../api";
import { CANCLE_CURRENT_EXERCISE } from "../../../api/apiRoutes";
import getId from "../../../../utils/getId";
import FutureTicketChange from "../futureTicket/changeDate";

interface IProps {
  ticket: Ticket;
  onRefreshTickets: () => void;
}

const SingleFutureTicketExercise: React.FC<IProps> = ({ ticket, onRefreshTickets }) => {
  const facilityIds = useFacility();
  const { t } = useTranslation();
  const [openDateChange, setOpenDateChange] = useState(false);
  const [openQrModal, setOpenQrModal] = useState(false);
  const [error, setError] = useState("");

  const handleSetOpenChangeDate = () => {
    setOpenDateChange(!openDateChange);
  };

  const handleSetOpenQrModal = () => {
    setOpenQrModal(!openQrModal);
  };

  const onResign = async () => {
    const { isError, errorTable } = await post(CANCLE_CURRENT_EXERCISE(getId(ticket.exercises[0]), facilityIds));
    if (isError) {
      setError(errorTable[0]);
    } else {
      handleSetOpenChangeDate();
    }
    onRefreshTickets();
  };

  return (
    <div className="single-future-ticket-container">
      <SingleFutureTicketDate date={ticket.exercises[0].startTime} />
      <SingleFutureTicketDetails
        exerciseName={ticket.exercises[0].name}
        date={ticket.exercises[0].startTime}
        ticketName={ticket.name}
      />
      <SingleFutureTicketActions
        ticketName={ticket.name}
        onSetOpenChangeDate={handleSetOpenChangeDate}
        onSetOpenQrModal={handleSetOpenQrModal}
        ticket={ticket}
        exerciseStartTime={new Date(ticket.exercises[0].startTime)}
      />

      <EAModal
        isOpen={openDateChange}
        title={t("zmiana_terminu")}
        onClose={handleSetOpenChangeDate}
        acceptButtonLabel={t("zrezygnuj")}
        onAccept={onResign}
      >
        <FutureTicketChange ticket={ticket} alert={error} />
      </EAModal>

      <EAModal
        isOpen={openQrModal}
        title={t("kod_qr")}
        onClose={handleSetOpenQrModal}
        hideAcceptButton
        cancelButtonLabel={t("gotowe_schowaj")}
      >
        <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
      </EAModal>
    </div>
  );
};

export default SingleFutureTicketExercise;
